import { InterProcessEvents } from '@highlight/ipc'

class HotkeyEvents extends InterProcessEvents {
  constructor() {
    super('hotkeys')
  }
}

export default new HotkeyEvents()
